import { ExportOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import { ButtonText, Error } from '../declaration-errors.styles';
import formatErrorField from './formatErrorField';
import { ErrorCard, ErrorCardField } from './types';
import { CardBody, CardNumber, CardRow, FieldLabel, RelatedFields } from './DeclarationErrorCard.styles';

interface Props {
    card: ErrorCard<unknown>;
    number: number;
    onGoToField: (field: ErrorCardField) => void;
    onShowDetails: () => void;
}

const FieldLink = ({
    field,
    label,
    onGoToField,
}: {
    field: ErrorCardField;
    label: string;
    onGoToField: Props['onGoToField'];
}) => (
    <Typography.Link onClick={() => onGoToField(field)}>
        {label} <ExportOutlined />
    </Typography.Link>
);

const DeclarationErrorCard = ({ card, number, onGoToField, onShowDetails }: Props) => (
    <CardRow>
        <CardNumber>{String(number).padStart(2, '0')}</CardNumber>

        <CardBody>
            <Error>{card.code ?? 'n/a'}</Error>
            <span>{card.message ?? '-'}</span>

            {card.fields.map((field) => (
                <FieldLink
                    key={`${field.item?.itemId ?? 'declaration'}-${field.formPath}`}
                    field={field}
                    label={field.label}
                    onGoToField={onGoToField}
                />
            ))}

            {card.related.length > 0 && (
                <RelatedFields>
                    <FieldLabel>Related fields</FieldLabel>
                    {card.related.map((field) => (
                        <FieldLink
                            key={`related-${field.item?.itemId ?? 'declaration'}-${field.formPath}`}
                            field={field}
                            label={formatErrorField(field)}
                            onGoToField={onGoToField}
                        />
                    ))}
                </RelatedFields>
            )}
        </CardBody>

        <ButtonText onClick={onShowDetails}>Show details</ButtonText>
    </CardRow>
);

export default DeclarationErrorCard;
